/** Configuración default de autocaptura. */
export const DEFAULT_AUTOCAPTURE_CONFIG = {
  enabled: true,
  captureClicks: true,
  captureSubmits: true,
  captureChanges: true,
  maskAllInputs: true,
  maskAllText: false,
  throttleMs: 100,
  maxTextLength: 200,
  captureElementMetadata: true,
  captureAncestors: 5,
} as const;

/** Máximo de niveles de ancestros que se permiten capturar. */
export const MAX_ANCESTORS = 10;

/** Selectores que SIEMPRE se ignoran (incluso si el cliente no configura blockSelectors). */
export const ALWAYS_BLOCK_SELECTORS = [
  '[data-veo-ignore]',
  '.veo-ignore',
  // Inputs sensibles
  'input[type="password"]',
  'input[type="email"]',
  'input[type="tel"]',
  'input[type="hidden"]',
  // Datos de tarjeta
  '[autocomplete="cc-number"]',
  '[autocomplete="cc-csc"]',
  '[autocomplete="cc-exp"]',
  '[autocomplete="cc-name"]',
  // Otros campos sensibles típicos
  '[name*="password" i]',
  '[name*="ssn" i]',
  '[name*="credit" i]',
  '[name*="card" i]',
  '[id*="password" i]',
  '[id*="ssn" i]',
];

/** Atributos sensibles que NUNCA se capturan. */
export const SENSITIVE_ATTRIBUTES = ['value', 'data-credit-card', 'data-ssn', 'data-password'];

/** Atributos útiles que SIEMPRE se intentan capturar si existen. */
export const PRIORITY_ATTRIBUTES = [
  'id',
  'name',
  'type',
  'role',
  'href',
  'data-action',
  'data-veo-tag',
  'data-testid',
  'aria-label',
  'aria-labelledby',
];

/** Regex para detectar clases generadas dinámicamente. Se descartan del selector. */
export const HASHED_CLASS_PATTERNS = [
  /^css-[a-z0-9]{4,}$/i, // emotion, styled-components nuevas
  /^_[a-z0-9]+_[a-z0-9]{4,}_\d+$/, // CSS Modules con hash
  /^[a-z]{2,4}-[a-z0-9]{6,}$/i, // Tailwind JIT (a veces)
  /^[a-f0-9]{6,}$/i, // hashes hex puros
  /^sc-[a-z0-9]+$/i, // styled-components legacy
];

/** Eventos sintéticos/internos que ignoramos. */
export const IGNORED_EVENT_PROPERTIES = ['$autocapture', 'pageview'];
